import React from 'react';
import logoLight from '../../assets/Pathbox-logo-v2-light.png';
import logoDark from '../../assets/Pathbox-logo-v2-dark.png';

export default function AuthLeftSide() {
  return (
    <div className="max-w-md mx-auto text-center">
      {/* Logo */}
      <div className="mb-8">
        <img 
          src={logoLight} 
          alt="Pathbox Logo" 
          className="h-16 mx-auto mb-4 dark:hidden"
        />
        <img 
          src={logoDark} 
          alt="Pathbox Logo" 
          className="h-16 mx-auto mb-4 hidden dark:block"
        />
      </div>

      {/* Main messaging - Hidden on mobile */}
      <div className="hidden lg:block space-y-6">
        <h1 className="text-4xl font-bold text-base-content">
          Welcome to Pathbox
        </h1>
        
        <p className="text-lg text-base-content/80 leading-relaxed">
          Transform and analyze your WSI with AI-powered digital pathology tools. Get insights, measurements, and detailed reports.
        </p>

        <div className="space-y-4 text-sm text-base-content/70">
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-primary rounded-full"></div>
            <span>AI-powered digital pathology</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-primary rounded-full"></div>
            <span>WSI analysis & insights</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <div className="w-2 h-2 bg-primary rounded-full"></div>
            <span>Detailed pathology reports</span>
          </div>
        </div>
      </div>

      {/* Link back to marketing site */}
      <div className="mt-12 pt-8 border-t border-base-content/20">
        <p className="text-sm text-base-content/60 mb-4 hidden lg:block">
          New to Pathbox? Learn more about our platform
        </p>
        <a 
          href="https://pathboxai.com" 
          target="_blank" 
          rel="noopener noreferrer"
          className="inline-flex items-center text-primary hover:text-primary-focus transition-colors duration-200 dark:text-primary-content dark:hover:text-primary-content/80"
        >
          <span>Visit pathboxai.com</span>
          <svg 
            className="w-4 h-4 ml-1" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
            />
          </svg>
        </a>
      </div>
    </div>
  );
}
